import { defineComponent } from '@vue/composition-api';

/**
 * 認証コンポーネント
 */
export default defineComponent({
});
